import { LoadSpinner } from '@calizahq/react-components-v2'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Card, LineItem } from '@/components'
import useJob from '@/hooks/useJobs/useJob'
import { formatDate, getJobStartTime, parseDate } from '@/util'
import { getFullAddress, isJobClaimed } from '@/util/JobUtil'

export const Job = () => {
  const { jobId } = useParams<{ jobId: string }>()
  const navigate = useNavigate()

  const jobQuery = useJob(Number(jobId))
  const job = jobQuery?.data?.job

  return (
    <div className="flex min-h-140 w-full flex-col p-6">
      <div className="mb-4 flex-col justify-start">
        <button className="button-text m-0 mb-3 p-0 text-sm underline" onClick={() => navigate(-1)}>{`< Back`}</button>
        <h2 className="text-xl">Job Detail</h2>
      </div>
      {jobQuery?.isLoading ? (
        <LoadSpinner />
      ) : !job || jobQuery?.isError ? (
        <div>Something went wrong. Please try again</div>
      ) : (
        <div>
          <Card cardClassName="mb-4">
            <div className="flex w-full flex-col px-4">
              <LineItem label="Name" value={job?.jobTemplate?.name} />
              <LineItem emptyCheck={true} label="Description" value={job?.description} />
              <LineItem label="Schedule Date" value={formatDate(parseDate(job?.scheduleDate), 'MM/dd/yyyy')} />
              <LineItem label="Starts At" value={getJobStartTime(job?.startsAt, job?.market?.timezone)} />
              <LineItem label="Created Date" value={formatDate(parseDate(job?.createdAt), 'MM/dd/yyyy')} />
            </div>
          </Card>

          <Card cardClassName="mb-4" headerText="More Details">
            <div className="flex w-full flex-col px-4">
              <LineItem emptyCheck={true} label="Host" value={job?.host?.fullName} />
              <LineItem emptyCheck={true} label="Member Name" value={job?.memberName} />
              <LineItem
                emptyCheck={true}
                label="Cancelled"
                tag={'info'}
                value={!!job?.cancelledAt ? 'Cancelled' : null}
              />
              <LineItem
                emptyCheck={true}
                label="Cancelled At"
                value={formatDate(parseDate(job?.cancelledAt), 'h:mmaaa, MM/dd/yyyy')}
              />
              <LineItem
                label="Claimed"
                tag={isJobClaimed(job) ? 'success' : 'warning'}
                value={isJobClaimed(job) ? 'Claimed' : 'Unclaimed'}
              />
              <LineItem
                emptyCheck={true}
                label="Claimed At"
                value={formatDate(parseDate(job?.claimedAt), 'h:mmaaa, MM/dd/yyyy')}
              />
              <LineItem
                emptyCheck={true}
                label="Started At"
                value={formatDate(parseDate(job?.startedAt), 'h:mmaaa, MM/dd/yyyy')}
              />
              <LineItem
                label="Completed"
                tag={job?.completed ? 'success' : 'info'}
                value={job?.completed ? 'Completed' : 'Not Completed'}
              />
              <LineItem label="Completed At" value={formatDate(parseDate(job?.completedAt), 'h:mmaaa, MM/dd/yyyy')} />
            </div>
          </Card>

          <Card cardClassName="mb-4" headerText="Location">
            <div className="flex w-full flex-col px-4">
              <LineItem label="Property" value={job?.home?.property?.name} />
              <LineItem label="Unit Number" value={job?.home?.unitNumber} />
              <LineItem label="Address" value={getFullAddress(job)} />
              <LineItem label="Market" value={job?.market?.name} />
              <LineItem label="Market Segment" value={job?.home?.property?.marketSegment} />
            </div>
          </Card>
        </div>
      )}
    </div>
  )
}
